import React from 'react';
import MultiSelectDropdown from './MultiSelectDropdown';
import { ICONS } from '../../utils/rescuePush';

/**
 * 轨迹推送表单面板
 */
export default function TrackPushPanel({
  organizations,
  groups,
  users,
  trackForm,
  setTrackForm,
  handleMultiSelect,
  selectAll,
  clearSelection,
  filterGroupsByOrg,
  filterUsersByGroup,
  handleFormChange,
  handleTrackFileChange,
  trackPreviewLoading,
  trackPreviewInfo,
  trackPreviewCoords,
  handleTrackPush,
  trackLoading,
  clearAllTracks,
  trackResult
}) {
  const sendDisabled =
    trackLoading || trackPreviewLoading || !(trackPreviewCoords && trackPreviewCoords.length >= 2);

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <label>轨迹文件：</label>
        <input
          type="file"
          accept=".kml,.gpx,.csv"
          onChange={handleTrackFileChange}
          style={{ width: '100%' }}
          disabled={trackPreviewLoading || trackLoading}
        />
        {trackPreviewLoading && (
          <div style={{ marginTop: 6, fontSize: 12, color: '#1976d2' }}>正在解析并预览...</div>
        )}
        {trackPreviewInfo && !trackPreviewLoading && (
          <div style={{ marginTop: 6, fontSize: 12, color: '#1976d2' }}>{trackPreviewInfo}</div>
        )}
      </div>
            <div
        style={{
          display: 'flex',
          gap: 12,
          marginBottom: 12,
          flexWrap: 'wrap',
          alignItems: 'flex-start'
        }}
      >
        <div style={{ flex: '1 1 160px', minWidth: 0 }}>
          <MultiSelectDropdown
            label="组织"
            options={organizations}
            selectedValues={trackForm.org_names}
            onSelectionChange={handleMultiSelect}
            formType="track"
            field="org_names"
            disabled={trackForm.to_all}
            onSelectAll={selectAll}
            onClearAll={clearSelection}
            style={{ marginBottom: 0 }}
          />
        </div>
        <div style={{ flex: '1 1 160px', minWidth: 0 }}>
          <MultiSelectDropdown
            label="小组"
            options={groups}
            selectedValues={trackForm.group_names}
            onSelectionChange={handleMultiSelect}
            formType="track"
            field="group_names"
            disabled={trackForm.to_all}
            cascadeFilter={filterGroupsByOrg}
            parentField="org_names"
            parentValues={trackForm.org_names}
            onSelectAll={selectAll}
            onClearAll={clearSelection}
            style={{ marginBottom: 0 }}
          />
        </div>
      </div>
      <MultiSelectDropdown
        label="用户"
        options={users}
        selectedValues={trackForm.user_names}
        onSelectionChange={handleMultiSelect}
        formType="track"
        field="user_names"
        disabled={trackForm.to_all}
        cascadeFilter={filterUsersByGroup}
        parentField="group_names"
        parentValues={trackForm.group_names}
        onSelectAll={selectAll}
        onClearAll={clearSelection}
      />
      <div style={{ marginBottom: 12 }}>
        <label>消息：</label>
        <input name="message" value={trackForm.message} onChange={handleFormChange(trackForm, setTrackForm)} style={{ width: '100%' }} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label>图标：</label>
        <select name="icon" value={trackForm.icon} onChange={handleFormChange(trackForm, setTrackForm)} style={{ width: '100%' }}>
          {ICONS.map((i) => (
            <option key={i.value} value={i.value}>
              {i.label}
            </option>
          ))}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label>
          <input
            type="checkbox"
            name="to_all"
            checked={trackForm.to_all}
            onChange={(e) => {
              const checked = e.target.checked;
              setTrackForm((f) => ({
                ...f,
                to_all: checked,
                org_names: checked ? [] : f.org_names,
                group_names: checked ? [] : f.group_names,
                user_names: checked ? [] : f.user_names
              }));
            }}
          />{' '}
          推送给所有人
        </label>
      </div>
      <div style={{ marginBottom: 18 }}>
        <button
          onClick={handleTrackPush}
          disabled={sendDisabled}
          style={{
            padding: '8px 32px',
            background: sendDisabled ? '#90caf9' : '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            fontWeight: 500,
            cursor: sendDisabled ? 'not-allowed' : 'pointer'
          }}
        >
          {trackLoading ? '推送中...' : '发送轨迹'}
        </button>
        <button
          onClick={clearAllTracks}
          style={{ padding: '8px 16px', background: '#f44336', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 500, marginLeft: 8 }}
        >
          清理轨迹
        </button>
        {trackResult && (
          <span style={{ marginLeft: 16, color: trackResult.success ? 'green' : 'red' }}>{trackResult.msg}</span>
        )}
      </div>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>
        💡 选择文件后会在右侧地图用<strong style={{ color: '#1976d2' }}>蓝色虚线</strong>
        预览（仅本页）。确认无误后点击「发送轨迹」，才会推送到指挥系统并显示为红色轨迹。
      </div>
    </>
  );
}
